// ============================================================
// FooterMentions — mentions légales YOU TECHNOLOGY
// ============================================================
// Affiché sur la page de connexion de la console Super Admin et
// dans toutes les applications de commerce.
//   variant="light"   → console Super Admin (fond clair, texte slate)
//   variant="dark"    → application commerce (fond sombre, texte gris)
//   variant="onlight" → fond clair commerce (ex. login bleu ciel) : texte foncé
// ============================================================
import React from 'react';
import { APP_VERSION } from '../../changelog';

export default function FooterMentions({ variant = 'dark', className = '' }) {
  const base = variant === 'light' ? 'text-slate-400'
    : variant === 'onlight' ? 'text-slate-700'
    : 'text-gray-500';
  const fort = variant === 'light' ? 'text-slate-500'
    : variant === 'onlight' ? 'text-slate-900'
    : 'text-gray-400';
  // « Quoi de neuf ? » présent côté commerce (variantes sombre + claire), pas sur la console SA.
  const estCommerce = variant !== 'light';

  // Ouvre le modal "Nouveautés" (écouté par NouveautesAuto, présent côté commerce).
  const ouvrirNouveautes = () => {
    window.dispatchEvent(new Event('sv:open-nouveautes'));
  };

  return (
    <div className={`text-center text-[11px] leading-relaxed ${base} ${className}`}>
      <p className={`font-medium ${fort}`}>© {new Date().getFullYear()} YOU TECHNOLOGY</p>
      <p>NIF : 351063094 · RCCM : KAL/042329B/12 · Tél. : 624 69 04 68</p>
      <p>Gestion des Commerces — Tous droits réservés.</p>
      <p>Conçu et développé à Conakry, Guinée 🇬🇳</p>
      {estCommerce && (
        <p className="mt-1">
          <button
            type="button"
            onClick={ouvrirNouveautes}
            className="underline decoration-dotted underline-offset-2 hover:text-yellow-600 transition-colors"
          >
            Quoi de neuf ?
          </button>
          <span className="mx-1.5 opacity-50">·</span>
          <span className="opacity-70">version {APP_VERSION}</span>
        </p>
      )}
    </div>
  );
}
